import { render, staticRenderFns } from "./WidgetForm.vue?vue&type=template&id=2a42d625&scoped=true&"
import script from "./WidgetForm.vue?vue&type=script&lang=ts&"
export * from "./WidgetForm.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetForm.vue?vue&type=style&index=0&id=2a42d625&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a42d625",
  null
  
)

export default component.exports